<template>
    <v-bottom-navigation v-if="data != null" dark fixed height="70">
       <div class="container py-0">
           <div class="row justify-end align-center" style="height: 100%!important;">
               <div class="col-auto py-0" v-for="btn in data.buttons">
                   <v-btn class="small-btns-smaller-screen" v-if="btn.outlined && btn.outlined == true" outlined :loading="btn.loading" style="min-width: 100px; font-size: 16px; padding-left: 56px; padding-right: 56px;" @click="btn.fn((btn.args)? btn.args : null)" :color="btn.color">
                       <span class="font-weight-bold white--text">{{btn.text}}</span>
                   </v-btn>
                   <v-btn class="small-btns-smaller-screen" v-else :loading="btn.loading"  style="min-width: 100px; height:100%; font-size: 16px; padding-left: 56px; padding-right: 56px;" @click="btn.fn((btn.args)? btn.args : null)" :color="btn.color">
                       <span class="font-weight-bold white--text">{{btn.text}}</span>
                   </v-btn>
               </div>
           </div>
       </div>
    </v-bottom-navigation>
</template>
<script>
    export default {
        computed:{
            data(){
                return this.$store.getters.bottom;
            }
        }
    }
</script>
